import React from "react";

export const InfoIndirectSales = ({ data }) => {
  if (!data) return null;

  const steps = data.steps || [];
  const misc = data.miscellaneous;

  const stepsTotal = steps.reduce((acc, item) => acc + (item.cost || 0), 0);
  const miscTotal = misc?.cost || 0;
  const grandTotal = stepsTotal + miscTotal;

  return (
    <div>
      {steps.map((item, index) => (
        <div
          key={index}
          className="flex flex-row justify-between items-center mb-2"
        >
          <h2 className="font-bold">{item.title}</h2>
          <p>Rs {item.cost}</p>
        </div>
      ))}

      {misc?.title && (
        <div className="flex flex-row justify-between items-center mb-4">
          <h2 className="font-bold">{misc.title}</h2>
          <p>Rs {misc.cost}</p>
        </div>
      )}

      <hr />
      <p className="font-bold uppercase mt-2">
        Total Cost - Rs {grandTotal}
      </p>
    </div>
  );
};
